{
  "card": {
    "streamRadio": "Stream radio",
    "untitledStream": "Untitled stream",
    "updateAndRestart": "Update & restart",
    "videoLoop": "Video loop"
  },
  "destinations": {
    "addStreamKey": "Add stream key",
    "createdAtLimit": "The new key was created but not selected. Your destination limit ({{max}}) is full; unselect a key to use it.",
    "cancel": "Cancel",
    "counter": "{{current}}/{{max}}",
    "delete": "Delete",
    "deleteDescription": "This will permanently remove this key.",
    "deleteTitle": "Delete stream key",
    "edit": "Edit",
    "emptyState": "Add a stream key to start broadcasting",
    "hide": "Hide",
    "showMorePlural": "Show {{count}} more keys",
    "showMoreSingular": "Show {{count}} more key",
    "title": "Stream destinations"
  },
  "detail": {
    "loadError": {
      "title": "We couldn't load this stream"
    },
    "planError": {
      "title": "We couldn't load this stream's plan"
    },
    "notFound": {
      "title": "Stream not found",
      "description": "This stream may have been deleted.",
      "action": "Back to streams"
    }
  },
  "list": {
    "columns": {
      "liveName": "Live name",
      "resolution": "Resolution",
      "status": "Status",
      "uptime": "Uptime"
    },
    "createNewLiveStreamSubtitle": "Start a new 24/7 live stream to grow your audience",
    "liveNow": "Live now",
    "pageTitle": "Live streams",
    "streamPlural": "streams",
    "streamSingular": "stream",
    "untitledStream": "Untitled stream",
    "welcomeChecklist": {
      "completed": "Done",
      "cta": "Get started",
      "startTrial": "Start free trial",
      "steps": {
        "connectPlatform": {
          "description": "Link your YouTube, Twitch, or Kick account.",
          "title": "Connect a streaming platform"
        },
        "createStream": {
          "description": "Set up your stream settings and start broadcasting.",
          "title": "Configure and go live"
        },
        "uploadContent": {
          "basicDescription": "Add videos for your Basic video loop stream.",
          "description": "Add videos or audio for your live stream.",
          "title": "Upload your content"
        }
      },
      "subtitle": "Here's what you'll do to launch your first 24/7 live stream:",
      "title": "Welcome to Streaminal"
    },
    "yourLiveStreams": "Your live streams",
    "loadError": {
      "title": "We couldn't load your streams"
    }
  },
  "notifications": {
    "analyticsConnected": "Analytics connected successfully!",
    "ended": "Live stream ended successfully!",
    "restarted": "Live stream restarted successfully!",
    "started": "Started live stream successfully",
    "updated": "Updated live stream successfully",
    "updateGeneric": "Update successfully!",
    "jumpRequested": "Jump requested. It won't happen while a jingle or show is playing.",
    "updateDeferred": "Saved. The live stream will update in a moment.",
    "startWaiting": "Waiting for your playlist media to finish processing before starting.",
    "startedWithPending": "Started with ready items. The remaining playlist media will apply after processing.",
    "updateWaiting": "Saved. Waiting for playlist media to finish processing."
  },
  "overlaysLocked": {
    "body": "Your overlays are kept and shown greyed out here. Upgrade to 1080p or 4K from the Subscription panel to edit and stream them.",
    "title": "Overlays are not rendered on the Basic plan"
  },
  "preview": {
    "mediaApply": {
      "startWaitingTitle": "Waiting for playlist media",
      "startWaitingDescription": "Your stream will start automatically when processing finishes. You can cancel this start at any time.",
      "startFailedTitle": "Start could not continue",
      "updateWaitingTitle": "Waiting for playlist media",
      "updateWaitingDescription": "Your current stream keeps playing. The saved playlist will apply when processing finishes.",
      "updateFailedTitle": "Playlist update could not continue",
      "failedGeneric": "Check your playlist and try again.",
      "reason": {
        "MEDIA_PROCESSING_FAILED": "One or more selected items failed processing. Remove the failed item or upload it again, then retry.",
        "NO_DESTINATION": "Enable a destination and try again.",
        "ENTITLEMENT_BLOCKED": "Check your subscription before trying again.",
        "SCHEDULE_END_PASSED": "The scheduled end time has passed. Update the schedule before trying again.",
        "MEDIA_CLEANUP_BLOCKED": "Media cleanup is still in progress. Try again shortly.",
        "WORKER_PAYLOAD_INVALID": "The stream could not prepare this playlist. Check the selected files and try again."
      }
    },
    "analytics": {
      "connectButton": "Connect analytics",
      "connectDescription": "Paste your YouTube live stream URL to enable analytics and advanced health monitoring",
      "connectTitle": "Connect YouTube analytics",
      "likes": "Likes",
      "range14d": "14 days",
      "range7d": "7 days",
      "rangeToday": "Today",
      "title": "Stream analytics",
      "viewers": "Viewers",
      "yAxisLikes": "Likes",
      "yAxisViewers": "Live viewers",
      "metricLabel": "Chart metric",
      "rangeLabel": "Date range"
    },
    "header": {
      "contentAndSettings": "Content & settings",
      "cancelStart": "Cancel start",
      "cancelStartTitle": "Cancel waiting start",
      "cancelStartBody": "Cancel the automatic start while playlist media is processing?",
      "restart": "Restart",
      "restartBody": "Are you sure you want to restart this live stream?",
      "restartTitle": "Restart live stream",
      "start": "Start",
      "startTitle": "Start live stream",
      "startBody": "Are you sure you want to start this live stream?",
      "statusArchived": "Archived",
      "statusCompiling": "Compiling",
      "statusEnded": "Ended",
      "statusEnding": "Ending",
      "statusFailedProvision": "Provisioning failed",
      "statusFinalizing": "Finalizing",
      "statusInitializing": "Initializing",
      "statusLive": "Live",
      "statusPartialFailed": "Partially live",
      "statusPaused": "Paused",
      "statusPausing": "Pausing",
      "statusPreparingMedia": "Preparing media",
      "statusRestarting": "Restarting",
      "statusResuming": "Resuming",
      "statusScheduled": "Scheduled",
      "statusStarting": "Starting",
      "statusStartMissed": "Start missed",
      "statusStopped": "Stopped",
      "statusStopping": "Stopping",
      "stop": "Stop",
      "stopBody": "Viewers see the stream end. You can start it again later.",
      "stopTitle": "Stop stream",
      "streamSettings": "Stream settings",
      "yes": "Yes",
      "retry": "Retry",
      "openLibrary": "Open library"
    },
    "metrics": {
      "duration": "Duration",
      "endOfContent": "End of content",
      "ends": "Ends",
      "endsAt": "Ends at",
      "likes": "Likes",
      "runningSmoothly": "Running smoothly",
      "runsIndefinitely": "Runs indefinitely",
      "startsAt": "Starts at",
      "upTime": "Up time",
      "viewers": "Viewers"
    },
    "playlist": {
      "confirmBody": "Are you sure you want to play this item now?",
      "confirmOk": "Yes",
      "confirmTitle": "Play this item now?",
      "nowPlaying": "Now playing",
      "tabPrimary": "Primary",
      "tabShows": "Shows",
      "title": "Playlist"
    },
    "readOnly": "Read-only",
    "shows": {
      "untitledShow": "Untitled show"
    },
    "stopped": {
      "hourPlural": "hours",
      "hourSingular": "hour",
      "minutePlural": "minutes",
      "minuteSingular": "minute",
      "ranFor": "Your live stream ran for {{duration}}.",
      "readyToGoAgain": "Ready to go again?",
      "setUp": "Choose content and destinations",
      "titleSetup": "Set up your stream",
      "titleStopped": "Stream has stopped",
      "updateAndStartNew": "Update & start new stream",
      "notStartedYet": "This stream hasn't gone live yet.",
      "titleEnded": "Stream has ended",
      "titlePaused": "Stream is paused"
    },
    "error": {
      "failedProvision": {
        "title": "Stream couldn't start",
        "body": "The streaming server couldn't be set up, so nothing went out to your destinations. Retry, or check your content and settings first.",
        "bodyNoRetry": "The streaming server couldn't be set up, so nothing went out to your destinations. Before the stream can start again, check its content, destinations and plan."
      },
      "partialFailed": {
        "title": "Some destinations aren't receiving the stream",
        "body": "Your stream is running, but at least one destination failed. Check its stream key in Content & settings, then retry.",
        "bodyNoRetry": "Your stream is running, but at least one destination failed. Before it can restart, check that destination's stream key, the content and the plan."
      },
      "startMissed": {
        "title": "Scheduled start was missed",
        "body": "The stream didn't start at its scheduled time. Retry to start it now, or change the schedule in Content & settings.",
        "bodyNoRetry": "The stream didn't start at its scheduled time. Before it can start, check its content, destinations and plan."
      }
    }
  },
  "settings": {
    "destinationsUnavailable": "Destination settings for this stream are unavailable right now. Existing destinations remain configured.",
    "checkboxes": {
      "enableCrossfade": "Enable crossfade audio mixing"
    },
    "fields": {
      "audioBitrate": "Audio bitrate",
      "audioCrossfadeDuration": "Audio crossfade duration",
      "endDate": "End date",
      "fadeIn": "Fade in",
      "fadeOut": "Fade out",
      "startDate": "Start date",
      "videoBitrate": "Video bitrate",
      "videoFPS": "Video FPS"
    },
    "modals": {
      "autoAudioMixing": "Auto audio mixing"
    },
    "planLocked": "Output settings are fixed by the Basic plan. Upgrade to 1080p or 4K to change them.",
    "radio": {
      "never": "Never",
      "neverHint": "(Keep it running 24/7)",
      "oneTimeStream": "(One-time content stream)",
      "scheduleDate": "Schedule a date",
      "startImmediately": "Start immediately",
      "whenContentFinishes": "When content finishes playing"
    },
    "rules": {
      "streamKeyRequired": "Please select at least one stream key"
    },
    "sections": {
      "advanced": "Advanced settings",
      "playback": "Playback settings",
      "scheduling": "Scheduling options",
      "videoFading": "Video fading"
    },
    "tooltips": {
      "clickForInfo": "Click for more information"
    },
    "warnings": {
      "bitrateTooHigh": "The selected bitrate is higher than the recommended value."
    },
    "units": {
      "seconds": "seconds"
    }
  },
  "startBlocked": {
    "archived": "This stream was archived.",
    "converting": "The stream is switching plans. It can start once every file is encoded.",
    "dunning_gated": "A payment failed. Retry the payment or update your card to start this stream.",
    "expired": "The subscription has expired. Resubscribe to start this stream.",
    "over_cap": "This stream uses more storage than its plan allows. Delete some files or add storage.",
    "trial_ended": "The free trial has ended. Convert to a paid plan to keep streaming.",
    "no_content": "Add at least one playable video or audio track before starting.",
    "no_destination": "Enable at least one destination before starting."
  },
  "startLiveStreamModal": {
    "goLive": "Go Live!",
    "nameHeading": "Let's give your live stream a name!",
    "namePlaceholder": "Name it something cool",
    "rightsCheckbox": "I either own or have secured all the necessary rights, licenses, written consents and releases necessary for the use of this content.",
    "termsCheckboxPrefix": "All the stream contents are in compliance with the ",
    "termsLink": "Terms & Conditions",
    "titleStart": "Start Live Stream",
    "titleUpdate": "Update Live Stream",
    "updateLiveStream": "Update Live Stream!"
  },
  "stepper": {
    "builder": {
      "backgroundStrip": {
        "add": "Add",
        "noBackgrounds": "No backgrounds yet",
        "title": "Backgrounds",
        "uploaded": "{{count}} uploaded",
        "deleteTitle": "Delete background",
        "deleteBody": "This background is deleted from the stream. You can't undo this.",
        "delete": "Delete",
        "cancel": "Cancel",
        "deleteLabel": "Delete {{name}}",
        "untitled": "Background"
      },
      "emptyCanvas": {
        "dragHint": "or drag & drop here",
        "headline": "Your audio plays over a background",
        "subtext": "Upload an image or video that viewers will see while your audio loops",
        "uploadButton": "Upload background"
      },
      "horizontal": "Horizontal (16:9)",
      "settingsCollapseLabel": "Stream settings",
      "sidebar": {
        "back": "Back",
        "custom": "Custom",
        "layers": "Layers",
        "overlays": "Overlays",
        "properties": "Properties",
        "settings": "Settings"
      },
      "title": "Stream builder",
      "toolbar": {
        "addCustomElements": "Custom elements",
        "redo": "Redo",
        "undo": "Undo"
      },
      "vertical": "Vertical (9:16)",
      "verticalLocked": "Vertical streams need the Pro plan.",
      "backgroundUpload": {
        "uploading": "Uploading background…",
        "tooBigTitle": "This file is too big",
        "tooBigBody": "Backgrounds can be up to {{size}} GB."
      }
    },
    "externalUpload": {
      "accessError": "Please make sure the file public access is enabled and the url is correct",
      "addAnother": "Add another source",
      "googleDrive": "Google Drive",
      "importFailed": "This file couldn't be imported. Check it is a playable video that is shared publicly, then try again.",
      "importedSuccess": "Imported successfully",
      "maxFileSizeError": "Max file size is {{size}}GB",
      "modalTitle": "Import video",
      "publicAccessHint": "Please make sure that your video link is publicly accessible (try it in incognito)",
      "startImport": "Start importing",
      "videosOnlyError": "Only videos are allowed"
    },
    "jingleCard": {
      "emptyStateLine1": "Drag music from your library and",
      "emptyStateLine2": "drop them here",
      "jinglePlural": "Jingles",
      "jingleSingular": "Jingle",
      "playback": "Playback:",
      "playEveryLabel": "Play a jingle every:",
      "songsLabel": "Songs",
      "subtitle": "Add jingles to be played during your live stream",
      "title": "Jingles playlist"
    },
    "library": {
      "actionsButton": "Actions",
      "addSelectedToPlaylist": "Add selected to playlist",
      "addSelectedToShow": "Add selected to show",
      "audioLibraryTitle": "My audio library",
      "deselectAll": "Deselect all",
      "emptyHint": "Upload your content first, then add it to your playlist.",
      "emptyState": "Looks empty here... Try uploading something by clicking the upload button",
      "emptyTitle": "Drop files here or click to upload",
      "fileRejected": "{{names}} can't be added here. Only {{kind}} files are accepted.",
      "filePlural": "files",
      "fileSingular": "file",
      "folderPlural": "folders",
      "folderSingular": "folder",
      "librarySubtitle": "This is where all your files will be uploaded to.",
      "newFolderButton": "New folder",
      "searchPlaceholder": "Search your library...",
      "selectAll": "Select all",
      "uploadButton": "Upload",
      "uploadExternalSource": "External source",
      "uploadFromComputer": "From computer",
      "uploadBlocked": "Uploads are paused for this stream. Check its plan and free storage.",
      "videoLibraryTitle": "My video library"
    },
    "media": {
      "heading": "Compose your playlist",
      "itemAlreadyInShow": "Item already exists in this show",
      "jingle": "Jingle",
      "musicEffects": "Music effects",
      "primaryPlaylist": "Primary playlist",
      "scheduledShows": "Scheduled shows",
      "subheading": "Drag, drop, and arrange your media to create the perfect stream"
    },
    "navigation": {
      "basicAudioDraft": "This audio draft is no longer available on Basic. Reload the saved stream as a video loop to continue.",
      "audioEditorUnavailable": "Editing this stream type is unavailable right now. Your existing stream can keep running.",
      "builderTitle": "Stream builder",
      "discardBody": "Your unsaved edits to this stream will be lost.",
      "discardConfirm": "Discard changes",
      "discardTitle": "Discard unsaved changes?",
      "mediaTitle": "Music",
      "nextButton": "Next",
      "prevButton": "Previous",
      "reloadAsVideoLoop": "Reload as video loop",
      "sizeNotice": "Some of the items you have selected are larger than the recommended resolution of {{resolution}}.",
      "sizeNoticeHint": "This may cause performance issues. Please resize them to {{resolution}} and upload the resized version.",
      "startLiveStream": "Start live stream",
      "streamTypeTitle": "Stream type",
      "updateAndGoLive": "Update & go live",
      "updateAndSchedule": "Update & schedule",
      "updateLiveStream": "Update live stream"
    },
    "playlistCard": {
      "deselectAll": "Deselect all",
      "emptyNoLibrary": "Your playlist will appear here.",
      "emptyStateLine1": "Drag music from your library and",
      "emptyStateLine2": "drop them here",
      "emptyWithLibrary": "Drag items from your library, or select them and click \"Add selected to playlist\".",
      "filePlural": "files",
      "fileSingular": "file",
      "playback": "Playback:",
      "removeAllBody": "Are you sure you want to remove all items from the playlist?",
      "removeAllTitle": "Remove all items from playlist",
      "removeSelected": "Remove selected from playlist",
      "searchPlaceholder": "Search your playlist...",
      "selectAll": "Select all",
      "subtitle": "This is what will be played in your live stream.",
      "title": "Live stream playlist"
    },
    "scheduledShow": {
      "addButton": "Add",
      "backgroundDifferent": "Different background",
      "backgroundOverlaysNote": "Note: Any overlays from the primary background will be applied to this show",
      "backgroundSame": "Same as primary background",
      "backgroundTitle": "Background",
      "dailyAt": "Daily at {{time}} ({{timezone}})",
      "deleteBody": "Are you sure you want to delete \"{{name}}\"?",
      "deleteTitle": "Delete show",
      "duration": "Duration:",
      "emptyStateLine1": "Drag music from your library and",
      "emptyStateLine2": "drop them here",
      "filePlural": "files",
      "fileSingular": "file",
      "nameLabel": "Name",
      "namePlaceholder": "Name",
      "nameRequired": "Show name is required",
      "namesMustBeUnique": "Show names must be unique",
      "nameTooLong": "Show name should be 30 letters or fewer",
      "startTime": "Airs:",
      "startTimeLabel": "Daily start time",
      "startTimeRequired": "Show start time is required",
      "switchImmediate": "Switch immediately",
      "switchModeDesc": "How to switch from the primary playlist to this show",
      "switchModeTitle": "Switch mode",
      "switchWait": "Wait for the current audio/video to finish",
      "timesMustBeUnique": "Another show already starts at this time",
      "timezoneLabel": "Time zone",
      "updateButton": "Update",
      "emptyShow": "The show \"{{name}}\" has no items. Add at least one item or delete the show.",
      "utcClashWarning": "This show starts at the same moment as \"{{name}}\", which uses another time zone. Only one of them will play at that time.",
      "addShowTitle": "Add show",
      "updateShowTitle": "Update show"
    },
    "secondaryCard": {
      "pendingBackground": "Wait for a selected video to finish processing before adding secondary audio.",
      "deselectAll": "Deselect all",
      "emptyStateLine1": "Drag music from your library and",
      "emptyStateLine2": "drop them here",
      "filePlural": "files",
      "fileSingular": "file",
      "removeAllBody": "Are you sure you want to remove all items from the playlist?",
      "removeAllTitle": "Remove all items from playlist",
      "removeSelected": "Remove selected from playlist",
      "searchPlaceholder": "Search your playlist...",
      "selectAll": "Select all",
      "subtitle": "Mixed with the primary audio. Usually for adding background music effect (rain, thunder, fireplace, additional background music...etc.)",
      "title": "Music effects playlist",
      "volumeLabel": "Volume:"
    },
    "showsCard": {
      "addShow": "Add show",
      "emptyStateHint": "Click the \"Add show\" button to add a new show",
      "emptyStateTitle": "No shows available",
      "showPlural": "shows",
      "showSingular": "show",
      "subtitle": "This is what will be scheduled to be played at a certain time.",
      "title": "Scheduled shows",
      "tooltipText": "Scheduled shows are playlists that will play at certain times everyday"
    },
    "streamType": {
      "continueButton": "Continue",
      "heading": "What do you want to stream?",
      "planLocked": "Not available on the Basic plan. Upgrade to Pro.",
      "radioFileTypes": "MP3, WAV, OGG files",
      "radioTagline": "Your audio plays on loop over a background image or video — perfect for music, podcasts, and radio-style streams.",
      "radioTitle": "Audio loop + background",
      "subheading": "Choose your streaming style",
      "videoFileTypes": "MP4, MOV, WEBM files",
      "videoLoopTagline": "Your videos play back-to-back on repeat — each one plays in full, then the next starts automatically.",
      "videoLoopTitle": "Video loop"
    },
    "staleDraft": {
      "title": "This stream changed since you started editing.",
      "reload": "Reload",
      "keep": "Keep my changes",
      "deletedTitle": "Content used by this draft was deleted. Reload the stream before saving."
    },
    "readOnlyLibrary": {
      "label": "Read-only media library",
      "video": "Video",
      "audio": "Audio",
      "back": "Back",
      "loading": "Loading media",
      "download": "Download",
      "downloadItem": "Download {{name}}",
      "delete": "Delete",
      "deleteItem": "Delete {{name}}",
      "deleteTitle": "Delete {{name}}?",
      "deleteBody": "The file is deleted from this stream's library. You can't undo this.",
      "cancel": "Cancel"
    },
    "sizeChip": {
      "overCap": "Over the storage limit"
    },
    "mediaCards": {
      "removeAll": "Remove all",
      "delete": "Delete",
      "cancel": "Cancel",
      "editShowLabel": "Edit {{name}}",
      "deleteShowLabel": "Delete {{name}}"
    },
    "playbackOrder": {
      "sequential": "Sequential",
      "shuffle": "Shuffle",
      "sequentialTooltip": "Play the items in the order they were added",
      "shuffleTooltip": "Play the items in a random order",
      "jingleSequentialTooltip": "Play the jingles in the order they were added",
      "jingleShuffleTooltip": "Play the jingles in a random order"
    }
  },
  "streamKey": {
    "addModal": {
      "title": "Add stream key"
    },
    "buttons": {
      "getStreamKey": "Get stream key",
      "save": "Save"
    },
    "editModal": {
      "title": "Update stream key"
    },
    "errors": {
      "generic": "Something went wrong"
    },
    "fields": {
      "channelId": "Channel name",
      "keyName": "Name",
      "platform": "Platform",
      "streamingUrl": "Stream URL",
      "streamKey": "Stream key",
      "channelIdOptional": "Channel name (optional)"
    },
    "hints": {
      "watchHow": "Watch how"
    },
    "notifications": {
      "added": "Stream key added",
      "deleted": "Stream key deleted",
      "updated": "Stream key updated",
      "applyOnUpdate": "Saved. Press \"Update live stream\" to apply this change to the running stream."
    },
    "placeholders": {
      "channelId": "Channel name",
      "keyName": "Give your key a cool name",
      "streamingUrl": "rtmp://rtmp.example.com/live",
      "streamKey": "Stream key"
    },
    "rules": {
      "channelIdRequired": "channelId is required",
      "keyNameRequired": "Key name is required",
      "streamingUrlInvalid": "The URL must start with rtmp:// or rtmps://",
      "streamingUrlRequired": "Streaming URL is required",
      "streamKeyInvalid": "Invalid stream key",
      "streamKeyRequired": "Stream key is required"
    }
  },
  "uploadBlocked": {
    "archived": "This stream was archived. Buy a new plan to stream again.",
    "converting": "Uploads are paused while the stream switches plans.",
    "expired": "Uploads are disabled while the subscription is expired. Renew the subscription to upload again.",
    "over_cap": "This stream is out of storage. Delete some files or add storage."
  },
  "customElementsLocked": {
    "title": "Custom elements are not available on this plan"
  },
  "platform": {
    "custom": "Custom"
  }
}
